// App.jsx
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { CartProvider } from "./context/CartContext";
import { CurrencyProvider } from "./context/CurrencyContext";
import { AuthProvider } from "./context/AuthContext";
import { OrderProvider } from "./context/OrderContext";
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

// Components
import ProtectedRoute from "./components/ProtectedRoute";
import AdminRoute from "./components/AdminRoute";
import ScrollToTop from "./components/ScrollToTop"; // Successfully imported!

// Pages
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductPage from "./pages/ProductPage";
import CartPage from "./pages/CartPage";
import Checkout from "./pages/Checkout";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import Account from "./pages/Account";
import Login from "./pages/Auth/Login";
import Register from "./pages/Auth/Register";
import Reviews from "./pages/ReviewsPage";

// Admin Pages
import AdminDashboard from "./admin/AdminDashboard";
import ProductManager from "./admin/ProductManager";
import OrdersManager from "./admin/OrdersManager";
import ReviewManager from "./admin/ReviewManager";
import AboutPage from "./pages/AboutPage";
import CareGuide from "./pages/CareGuide";
import CustomerCare from "./pages/CustomerCare";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import PureMadness from "./pages/PureMadness";

const App = () => {
    return (
        <HelmetProvider>
            <AuthProvider>
                {/* CurrencyProvider must wrap CartProvider: the cart prices itself in the visitor's currency */}
                <CurrencyProvider>
                    <CartProvider>
                        <OrderProvider>
                            <Router>
                                <ScrollToTop />
                                <Routes>
                                    {/* Public Routes */}
                                    <Route path="/" element={<Home />} />
                                    <Route path="/shop" element={<Shop />} />
                                    <Route path="/pure-madness" element={<PureMadness />} />
                                    <Route path="/product/:id" element={<ProductPage />} />
                                    <Route path="/login" element={<Login />} />
                                    <Route path="/register" element={<Register />} />
                                    <Route path="/about" element={<AboutPage />} />
                                    <Route path="/care-guide" element={<CareGuide />} />
                                    <Route path="/reviews" element={<Reviews />} />
                                    <Route path="/customer-care" element={<CustomerCare/>} />
                                    <Route path="/terms" element={<Terms />} />
                                    <Route path="/privacy" element={<Privacy />} />
                                    <Route path="/cart" element={<CartPage />}/>
                                    <Route path="/checkout" element={<Checkout />}/>
                                    <Route path="/checkout-success" element={<CheckoutSuccess />}/>

                                    {/* Protected Customer Routes */}
                                    <Route
                                        path="/account"
                                        element={
                                            <ProtectedRoute>
                                                <Account />
                                            </ProtectedRoute>
                                        }
                                    />

                                    {/* Admin Only Routes */}
                                    <Route
                                        path="/admin"
                                        element={
                                            <AdminRoute>
                                                <AdminDashboard />
                                            </AdminRoute>
                                        }
                                    />
                                    <Route
                                        path="/admin/products"
                                        element={
                                            <AdminRoute>
                                                <ProductManager />
                                            </AdminRoute>
                                        }
                                    />
                                    <Route
                                        path="/admin/orders"
                                        element={
                                            <AdminRoute>
                                                <OrdersManager />
                                            </AdminRoute>
                                        }
                                    />
                                    <Route
                                        path="/admin/reviews"
                                        element={
                                            <AdminRoute>
                                                <ReviewManager />
                                            </AdminRoute>
                                        }
                                    />

                                    {/* Fallback route */}
                                    <Route path="*" element={<Home />} />
                                </Routes>
                            </Router>
                        </OrderProvider>
                    </CartProvider>
                </CurrencyProvider>
            </AuthProvider>
        </HelmetProvider>
    );
};

export default App;